export const featuresData = {
  availability: [
    'No data',
    'Unavailable',
    'Available',
    'Available with limit',
  ],
  status: ['Software house', 'Freelancer'],
  roles: ['Backend', 'Frontend', 'Android', 'iOS', 'QA'],
  skills: [
    'Angular',
    'React.js',
    'Vue.js',
    'Backbone.js',
    'Ember.js',
    'JavaScript',
    'Java',
    '.NET',
    'PHP',
    'Python',
    'Ruby',
    'NodeJS',
    'Scala',
    'GoLang',
    'Django',
    'C',
    'C++',
    'Android',
    'iOS',
    'Cross-platform',
    'Xamarin',
    'React Native',
    'Cordova',
    'Ionic',
    'Unity',
    'Cypress.io',
    'Percy.io',
    'REST API',
    'HTML',
    'TypeScript',
  ],
  top_skills: [
    'Angular',
    'React.js',
    'Vue.js',
    'Backbone.js',
    'Ember.js',
    'JavaScript',
    'Java',
    '.NET',
    'PHP',
    'Python',
    'Ruby',
    'NodeJS',
    'Scala',
    'GoLang',
    'Django',
    'C',
    'C++',
    'Android',
    'iOS',
    'Cross-platform',
    'Xamarin',
    'React Native',
    'Cordova',
    'Ionic',
    'Unity',
    'Cypress.io',
    'Percy.io',
    'REST API',
    'HTML',
    'TypeScript',
  ],
  contract_types: ['B2B', 'B2C', 'B2D'],
  currency: ['USD', 'PLN'],
  hobbies: [
    'Basketball',
    'Football',
    'Volleyball',
    'Marathon running',
    'Skiing',
    'Tennis',
    'Cycling',
    'Swimming',
    'Baseball',
    'Mountain climbing',
    'Chess',
    'Playing a musical instrument',
    'Reading',
    'Writing',
    'Sketching',
    'Photography',
    'Design',
    'Blog writing',
    'Painting',
    'Boardgames',
    'Creating and organizing a book club',
    'Networking events',
    'Local meetups',
    'Volunteering at a charity center',
    'Public speaking',
    'Exploring other cultures',
    'Dancing',
    'Camping',
    'Language classes',
    'Archery',
    'Gardening',
    'Stand-up comedy',
    'Baking',
    'Journaling',
    'Calligraphy',
    'Fencing',
    'Theater',
    'Yoga',
    'Languages',
  ],
  management: ['SCRUM', 'Agile', 'Kanban', 'Waterfall'],
  nationality: ['Polish', 'British', 'German', 'Czech'],
  language_name: ['English', 'German', 'French', 'Italian'],
  language_level: ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'],
  languages: [
    { name: 'English', level: 'A1' },
    { name: 'English', level: 'A2' },
    { name: 'English', level: 'B1' },
    { name: 'English', level: 'B2' },
    { name: 'English', level: 'C1' },
    { name: 'English', level: 'C2' },
    { name: 'German', level: 'A1' },
    { name: 'German', level: 'A2' },
    { name: 'German', level: 'B1' },
    { name: 'German', level: 'B2' },
    { name: 'German', level: 'C1' },
    { name: 'German', level: 'C2' },
    { name: 'French', level: 'A1' },
    { name: 'French', level: 'A2' },
    { name: 'French', level: 'B1' },
    { name: 'French', level: 'B2' },
    { name: 'French', level: 'C1' },
    { name: 'French', level: 'C2' },
    { name: 'Italian', level: 'A1' },
    { name: 'Italian', level: 'A2' },
    { name: 'Italian', level: 'B1' },
    { name: 'Italian', level: 'B2' },
    { name: 'Italian', level: 'C1' },
    { name: 'Italian', level: 'C2' },
  ],
  level: ['Junior', 'Regular', 'Senior', 'Expert'],
  project_areas: [
    'B2C',
    'B2B',
    'Fashion',
    'Retail',
    'Cloud',
    'Sharing Economy',
    'Gaming',
    'MedTech',
    'AdTech',
    'Fintech',
    'Events',
    'Transportation',
    'EcoTech',
    'IoT',
    'AR',
    'AI',
    'Beauty',
    'Music',
    'Lifestyle',
    'Banking',
    'Charity',
    'Cleantech',
    'Art',
    'Gambling',
    'Insurtech',
    'Wearables',
    'SaaS',
    'Productivity',
    'Startups',
    'Apps',
    'Web Tools',
    'Marketing',
    'Artificial Intelligence',
    'Social Media Tools Analytics',
    'Education',
    'Mobile',
    'Social Networking',
    'Developer Tools',
    'Ecommerce',
    'Finance',
    'Marketing Automation',
    'HR',
    'Recruitment process',
    'Cryptocurrencies',
    'Entrepreneur',
    'Chat',
    'Customer Support',
    'Advertising',
    'Marketplaces',
    'Community',
    'Lead Generation',
    'Messaging',
    'Video',
    'Big Data',
    'Real Estate',
    'Workflows',
    'Accounting',
    'Investing',
    'Entertainment',
  ],
  technologies: [
    'Angular',
    'React.js',
    'Vue.js',
    'Backbone.js',
    'Ember.js',
    'JavaScript',
    'Java',
    '.NET',
    'PHP',
    'Python',
    'Ruby',
    'NodeJS',
    'Scala',
    'GoLang',
    'Django',
    'C',
    'C++',
    'Android',
    'iOS',
    'Cross-platform',
    'Xamarin',
    'React Native',
    'Cordova',
    'Ionic',
    'Unity',
    'Cypress.io',
    'Percy.io',
    'REST API',
    'HTML',
    'TypeScript',
  ],
  tools: [
    'GitLab',
    'GitHub',
    'Jira',
    'Trello',
    'Postman',
    'pgAdmin',
    'Swagger',
    'Kibana',
    'Adobe XD',
    'Zeplin',
    'Avocode',
    'CircleCI',
    'Heroku',
    'Docker',
    'Bitbucket',
  ],
  working_hours: ['part-time', 'full-time'],
  verification_status: ['Verified', 'Unverified', 'Failed'],
};

export const companySizes = [
  { value: 'micro', name: '1' },
  { value: 'tiny', name: '2-9' },
  { value: 'small', name: '10-99' },
  { value: 'medium', name: '100-500' },
  { value: 'large', name: '500-1000' },
  { value: 'huge', name: '1000+' },
];
